import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import Footer from "../components/Footer";
import "./CartPage.css";

const CartPage = () => {
  const { cartItems, updateQuantity, removeFromCart, cartTotal } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-empty">
          <div className="cart-empty-icon">🛍️</div>
          <h2>Your bag is empty</h2>
          <p>Add some products to get started.</p>
          <Link to="/products" className="cart-shop-btn">Shop Now</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h1 className="cart-title">Your Bag</h1>

        <div className="cart-content">
          {/* Items */}
          <div className="cart-items">
            {cartItems.map((item) => (
              <div className="cart-item" key={item.id}>
                <img src={item.image} alt={item.name} className="cart-item-img" />
                <div className="cart-item-details">
                  <p className="cart-item-name">{item.name}</p>
                  <p className="cart-item-unit">₹{item.price} each</p>
                </div>
                <div className="qty-control">
                  <button className="qty-btn" onClick={() => item.quantity === 1 ? removeFromCart(item.id) : updateQuantity(item.id, item.quantity - 1)}>−</button>
                  <span className="qty-value">{item.quantity}</span>
                  <button className="qty-btn" onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                </div>
                <p className="cart-item-subtotal">₹{item.price * item.quantity}</p>
              </div>
            ))}
          </div>

          {/* Summary */}
          <div className="cart-summary">
            <h2 className="cart-summary-title">Order Summary</h2>
            {cartItems.map((item) => (
              <div className="cart-summary-row" key={item.id}>
                <span>{item.name} × {item.quantity}</span>
                <span>₹{item.price * item.quantity}</span>
              </div>
            ))}
            <div className="cart-summary-divider" />
            <div className="cart-summary-total">
              <span>Total</span>
              <span>₹{cartTotal}</span>
            </div>
            <button className="cart-checkout-btn" onClick={() => navigate("/checkout")}>
              Proceed to Checkout
            </button>
            <Link to="/products" className="cart-continue-link">← Continue Shopping</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CartPage;
